import { createFileRoute } from '@tanstack/react-router';
import { MasterDataPage } from '@/modules/master-data/master-data-page';

export const Route = createFileRoute('/_auth/master-data')({
  component: MasterDataPage,
  validateSearch: (search: Record<string, unknown>) => ({
    upload: typeof search.upload === 'string' ? search.upload : undefined,
    day: typeof search.day === 'string' ? search.day : undefined,
    scope: typeof search.scope === 'string' ? search.scope : undefined,
  }),
});
